import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBottomCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 600px (past hero)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-29">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-blue-100 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] p-3 md:p-4" data-id="element-30">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-31">
            <div className="hidden sm:flex flex-col" data-id="element-32">
              <div className="flex items-center gap-2 text-sm text-slate-500 mb-1" data-id="element-33">
                <span className="flex items-center gap-1 text-green-600 font-bold" data-id="element-34">
                  <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-35"></span>
                  Oferta Activa
                </span>
                <span data-id="element-36">•</span>
                <span data-id="element-37">Termina en:</span>
                <CountdownTimer variant="light" className="scale-75 origin-left" data-id="element-38" />
              </div>
              <div className="flex items-baseline gap-2" data-id="element-39">
                <span className="text-slate-400 line-through text-sm" data-id="element-40">
                  $35.000
                </span>
                <span className="text-2xl font-black text-blue-600" data-id="element-41">
                  $19.990
                </span>
              </div>
            </div>

            <div className="w-full sm:w-auto flex flex-col gap-1" data-id="element-42">
              <a href="https://checkout3.rosetadigital.com/cart/45857309196473:1" className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg flex items-center justify-center gap-2 transition-transform hover:scale-105 active:scale-95" data-id="element-43">
                DESCARGAR AHORA <ArrowRight className="w-5 h-5" data-id="element-44" />
              </a>
              <div className="flex items-center justify-center gap-1 text-[10px] text-slate-400 sm:hidden" data-id="element-45">
                <Lock className="w-3 h-3" data-id="element-46" /> Pago 100% Seguro
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}